import * as env from "../../config/env.json";
export default {
  created() {
    const originalFetch = window.fetch;
    window.fetch = (url, options) => {
      const headers = {
        ...options.headers, // Merge with existing headers
      };

      if (!url.toLowerCase().includes("login")) {
        headers.Authorization = "Bearer " + sessionStorage.getItem("token");
      }

      if (url.toLowerCase().includes("backoffice-api")) {
        headers["x-api-key"] = env.BO_API_KEY_;
      } else {
        headers["x-api-key"] = env.API_KEY;
      }

      // Make the request with the updated headers
      return originalFetch(url, { ...options, headers })
        .then((response) => {
          return response;
        })
        .catch(() => {
          //throw error;
        });
    };
  },
};
